module.exports = __webpack_public_path__ + "img/MysteryOfTheClockwork_EGM.e1eb83ea.jpg";